/**
 * Événements du parcours ménage, envoyés à la source Better Stack
 * `frontend-events` (cf. `plugins/tracking.plugin.ts`). Les noms sont ceux
 * qu'émettait l'ancien suivi : l'entonnoir se relit à l'identique.
 */
export const TRACKING_EVENTS = {
    CLICK_BUTTON: "Button Clicked",
    DEAD_CLICK_DETECTED: "Dead Click Detected",

    STEP_ENTERED: "Step Entered",
    STEP_COMPLETED: "Step Completed",

    FORM_COMPLETED: "Form Completed",
    FORM_INAVLID: "Form Invalid",
    FORM_ABANDONED: "Form Abandoned",
}
